/*
 * @Descripttion: 
 * @Author: zhanghang
 * @Date: 2022-11-28 13:54:27
 * @LastEditors: zhanghang
 * @LastEditTime: 2022-11-28 14:56:04
 */
export default {
  install(Vue) {
    Vue.directive("warnLine", function (el, bind) {
      let value = bind.value
      let ab = bind.modifiers.ab
      let src = "data:image/png;base64,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"
      let img = $(`<img src="${src}" class="directive-warnLine-warning" style="width:20px;height:20px;position:absolute;left:-10px;top:-10px"/>`)
     
      if (!ab) {
        $(el).css('position', "relative")
      }

      if (value) {

        $(el).addClass('directive-warnLine-warning-parent')

        let child = $(el).children('.directive-warnLine-warning')

        if (!child.length) {
          $(el).append(img)
        }

      } else {
        $(el).removeClass('directive-warnLine-warning-parent')
        $(el).children('.directive-warnLine-warning').remove()
      }


    });
  }
};